import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ClaimViewModel } from 'models';

@Injectable({ providedIn: 'root' })
export class UserClaimsService {
	constructor(private http: HttpClient) {}

	assignClaims(userId: string, claims: ClaimViewModel[]): Observable<void> {
		return this.http.put<void>(`api/accounts/user/${userId}/assignclaims`, claims);
	}

	removeClaims(userId: string, claims: ClaimViewModel[]): Observable<void> {
		return this.http.put<void>(`api/accounts/user/${userId}/removeclaims`, claims);
	}
}
